import { Avatar, Button, Typography } from '@mui/material';
import { Box } from '@mui/system';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import CopyrightTemplate from '../../../widgets/template/Copyright';

const ConfirmEmailModule = () => {
  let history = useHistory();

  return (
    <center>
      <Box
        sx={{
          width: '30%',
        }}
      >
        <Avatar
          alt="On Pass"
          src="./img/logoon.png"
          sx={{ width: 150, height: 150, padding: '20px' }}
        />
        <Typography component="h1" variant="h3" sx={{ fontWeight: '700' }}>
          ON PASS
        </Typography>
        <Typography sx={{ mt: 2, mb: 2 }} component="h1" variant="h5">
          Correo electrónico confirmado
        </Typography>
        <Box
          xs={{
            height: '20%',
          }}
        >
          Pariatur in sunt Lorem ipsum Lorem culpa fugiat magna non proident
          culpa eu eiusmod. In mollit sunt qui reprehenderit do. Reprehenderit
          consequat eu mollit mollit et et fugiat exercitation. Dolore cillum ad
          veniam deserunt occaecat. Sunt qui proident nulla reprehenderit
          voluptate occaecat ullamco est magna sunt. Exercitation dolore cillum
          quis cillum veniam est laborum quis.
        </Box>
        <Button
          sx={{
            mt: 3,
            mb: 3,
          }}
          onClick={() => {
            history.push('/');
          }}
        >
          Volver al Inicio de Sesión
        </Button>
        <CopyrightTemplate sx={{ mt: 5 }} />
      </Box>
    </center>
  );
};

export default ConfirmEmailModule;
